import { render, staticRenderFns } from "./MinimizedFileManager.vue?vue&type=template&id=797278af&scoped=true"
import script from "./MinimizedFileManager.vue?vue&type=script&lang=js"
export * from "./MinimizedFileManager.vue?vue&type=script&lang=js"
import style0 from "./MinimizedFileManager.vue?vue&type=style&index=0&id=797278af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797278af",
  null
  
)

export default component.exports